import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ProfilePictureWithIndicators from "../../Presentational/ProfilePictureWithIndicators/ProfilePictureWithIndicators";
import ProfilePicture from "../../Presentational/Person/ProfilePicture/ProfilePicture";
import Attachment from "../../Presentational/Attachment/Attachment";
import FAIcon from "../../UI/FAIcon/FAIcon";
import LinkToPerson from "../../Presentational/Person/LinkToPerson/LinkToPerson";
const MessageThread = (props) => {
    var _a;
    const renderSenderName = () => {
        var _a, _b;
        if ((_a = props === null || props === void 0 ? void 0 : props.thread) === null || _a === void 0 ? void 0 : _a.hasPermissionToViewStudentsProfile) {
            return (_jsx(LinkToPerson, { affiliationId: props.thread.senderId, children: _jsx("h2", { className: "mb-1 h5", children: props.thread.senderFullName }) }));
        }
        return _jsx("h2", { className: "mb-1 h5", children: (_b = props === null || props === void 0 ? void 0 : props.thread) === null || _b === void 0 ? void 0 : _b.senderFullName });
    };
    const renderDeliveryStatus = () => {
        if (props.thread.deliveryStatus) {
            // We have the deliveryStatus
            let sentToDestinationsText = "";
            let icon;
            let iconType = "text-success";
            let screenOnlyText;
            if (props.thread.destinations) {
                sentToDestinationsText = `Sent to ${props.thread.destinations} \n`;
            }
            if (!props.thread.readDate) {
                sentToDestinationsText += `Delivered by ${props.thread.smsDelivery ? "text message" : "email"} `;
                icon = props.thread.smsDelivery
                    ? "fas fa-mobile-alt"
                    : "fal fa-envelope";
                screenOnlyText = `Delivered via ${props.thread.smsDelivery ? "text message" : "email"}`;
            }
            else {
                sentToDestinationsText += `Read - ${props.thread.readDate} `;
                icon = props.thread.smsDelivery
                    ? "fas fa-mobile-alt"
                    : "fal fa-envelope-open";
                screenOnlyText = `Read - ${props.thread.readDate}`;
            }
            if (props.thread.errorMessage) {
                sentToDestinationsText += `${props.thread.errorMessage}`;
                iconType = "text-warning";
                if (!props.thread.readDate) {
                    screenOnlyText += ` - ${props.thread.errorMessage}`;
                }
            }
            return (_jsx("div", { className: "ml-2 mr-1", children: _jsxs("span", { title: sentToDestinationsText, children: [_jsx("span", { className: `${icon} ${iconType} fa-fw`, "aria-hidden": "true" }), _jsx("span", { className: "sr-only", children: screenOnlyText })] }) }));
        }
        if (props.thread.errorMessage) {
            let titleText;
            if (props.thread.destinations) {
                titleText = `Sent to ${props.thread.destinations} \n`;
            }
            titleText += `Undeliverable - ${props.thread.errorMessage}`;
            return (_jsxs("span", { className: "ml-2 mr-1 text-danger", title: titleText, children: [_jsx("span", { className: "fa fa-exclamation-triangle fa-fw", "aria-hidden": "true" }), _jsx("span", { className: "sr-only", children: "Undeliverable" })] }));
        }
        return "";
        // No deliveryStatus
    };
    const renderAttachments = () => {
        var _a;
        return (_jsx("div", { className: "d-flex flex-wrap", children: (_a = props === null || props === void 0 ? void 0 : props.thread) === null || _a === void 0 ? void 0 : _a.attachments.map((attachment, index) => (_jsx(Attachment, { attachment: attachment, className: "mr-3 mb-3" }, index))) }));
    };
    const renderNotes = () => {
        var _a;
        if ((_a = props === null || props === void 0 ? void 0 : props.thread) === null || _a === void 0 ? void 0 : _a.noteCount) {
            return (_jsx("div", { children: _jsxs("small", { children: ["Notes: ", props.thread.noteCount] }) }));
        }
        return null;
    };
    const renderDestinations = () => {
        var _a;
        if ((_a = props === null || props === void 0 ? void 0 : props.thread) === null || _a === void 0 ? void 0 : _a.destinations) {
            return (_jsxs("small", { className: "text-muted", children: [" To: ", props.thread.destinations] }));
        }
        return null;
    };
    const renderProfilePicture = () => {
        var _a;
        const profilePicture = (_jsx("div", { className: "mr-3", children: _jsx(ProfilePictureWithIndicators, { profilePicture: _jsx(ProfilePicture, { person: props.thread.sender, showProfilePicture: true }), showIndicators: true, hasPermissionForTermSuccessScore: props.hasPermissionForTermSuccessScore, hasPermissionForCourseSuccessScore: props.hasPermissionForCourseSuccessScore, courseSuccessScore: props.thread.sender.transcriptSuccessScoringGroup, termSuccessScore: props.thread.sender.successScoringGroup }) }));
        if ((_a = props === null || props === void 0 ? void 0 : props.thread) === null || _a === void 0 ? void 0 : _a.hasPermissionToViewStudentsProfile) {
            return (_jsx(LinkToPerson, { affiliationId: props.thread.senderId, className: "text-dark", style: { textDecoration: "none" }, children: profilePicture }));
        }
        return profilePicture;
    };
    return (_jsx("div", { className: "flex-column align-items-stretch", children: _jsxs("div", { className: "media border-bottom py-4", children: [renderProfilePicture(), _jsxs("div", { className: "media-body", children: [_jsxs("div", { className: "mead-heading d-flex flex-row align-items-baseline justify-content-between", children: [_jsxs("div", { className: "d-flex align-items-baseline flex-column", children: [renderSenderName(), renderDestinations(), _jsx("small", { className: "text-muted", children: props.thread.sentDate })] }), _jsxs("div", { className: "d-flex align-items-baseline", children: [props.thread.logged && (_jsx(FAIcon, { icon: "archive", className: "text-primary", srText: "This message was logged", title: "This message was logged", fixedWidth: true })), renderDeliveryStatus()] })] }), _jsx("div", { className: "mb-3", 
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML: { __html: ((_a = props === null || props === void 0 ? void 0 : props.thread) === null || _a === void 0 ? void 0 : _a.message) || "" } }), renderAttachments(), renderNotes(), _jsxs("button", { type: "button", className: "btn btn-sm btn-outline-secondary", onClick: props.onAddNote, children: [_jsx(FAIcon, { icon: "plus", srText: "Log this message", title: "Log this message", fixedWidth: true, addMarginRight: true }), "Add Note"] }), !props.thread.logged && props.hasPermissionToLogMessage && (_jsxs("button", { type: "button", className: "btn btn-sm btn-outline-secondary ml-2", onClick: props.onLogMessage, children: [_jsx(FAIcon, { icon: "archive", srText: "Log this message", title: "Log this message", fixedWidth: true, addMarginRight: true }), "Log"] }))] })] }) }));
};
export default MessageThread;
